import React, { useState, useEffect } from 'react';
import styles from './CciTrend.module.css';
import { Row, Col, Card, Tooltip, Space, Spin, Select, message } from 'antd';
import { fetchTrend } from '../../../../api';
import { Line } from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';

const { Option } = Select;

const CciTrend = () => {
    const [trendData, setTrendData] = useState({
        cciTrend: '',
        cciRel: '',
        labelDt: ['Dec 19', 'Jan 20', 'Feb 20', 'Mar 20', 'Apr 20', 'May 20', 'Jun 20', 'Jul 20', 'Aug 20', 'Sep 20', 'Oct 20', 'Nov 20'],
        labelRel: '',
        appRes2appErr: {
            app_res: '',
            app_err: '',
            app_comms: '',
        },
        app_res_ml: '',
        avgAppRes: '',
        cusReq: '',
        appsRel: '',
        totalAppsRel: '',
        appsRef: '',
    });
    const [trendLoad, setTrendLoading] = useState(true);
    const [chngLoad, setChngLoading] = useState(true);
    const [limiter, setLimiter] = useState(12);
    const [submit, setSubmit] = useState(true);

    useEffect(() => {
        fetchData();
    }, [submit]);

    const fetchData = async () => {
        setTrendLoading(true);
        const cciTrend = await fetchTrend('fetCciTrend', limiter);
        const cciRel = await fetchTrend('fetCciRel', limiter);

        setTrendData({
            cciTrend: cciTrend,
            cciRel: cciRel,
            labelDt: cciTrend['date'].split(',').reverse(),
            labelRel: cciRel['rel'].split(',').reverse(),
            appRes2appErr: {
                app_res: cciTrend['app_res'].split(',').reverse(),
                app_err: cciTrend['app_err'].split(',').reverse(),
                app_comms: cciTrend['comms']
                    .split(',')
                    .map((x) => (x.includes('.') ? x.split('.') : x))
                    .reverse(),
            },
            app_res_ml: cciTrend['app_res_ml'].split(',').reverse(),
            avgAppRes: cciTrend['avgapp_res'].split(',').reverse(),
            cusReq: cciTrend['cus_req'].split(',').reverse(),
            appsRel: cciRel['apps'].split(',').reverse(),
            totalAppsRel: cciRel['totalapps'].split(',').reverse(),
            appsRef: cciTrend['appsRef'].split(',').reverse(),
            inactive: cciRel['inactive'].split(',').reverse(),
            discovery: cciRel['discovery'].split(',').reverse(),
            unRes: cciRel['apps']
                .split(',')
                .reverse()
                .map((i, index) => {
                    return (
                        parseInt(cciRel['totalapps'].split(',').reverse()[index]) -
                        parseInt(i) -
                        (parseInt(cciRel['inactive'].split(',').reverse()[index]) +
                            parseInt(cciRel['discovery'].split(',').reverse()[index]))
                    );
                }),
            unResFill: cciRel['totalapps']
                .split(',')
                .reverse()
                .map((i, index) => {
                    return parseInt(i);
                }),
            inactiveFill: cciRel['apps']
                .split(',')
                .reverse()
                .map((i, index) => {
                    return parseInt(i) + parseInt(cciRel['inactive'].split(',').reverse()[index]);
                }),
            discoveryFill: cciRel['apps']
                .split(',')
                .reverse()
                .map((i, index) => {
                    return (
                        parseInt(i) +
                        parseInt(cciRel['inactive'].split(',').reverse()[index]) +
                        parseInt(cciRel['discovery'].split(',').reverse()[index])
                    );
                }),
            breach: cciTrend['breach'].split(',').reverse(),
            japanese: cciTrend['japanese'].split(',').reverse(),
        });

        setTrendLoading(false);
        setChngLoading(!chngLoad);
    };

    function onChange(value) {
        // console.log(`selected ${value}`);
        // alert(`selected ${value}`);
        if (value === '100') {
            message.info(`All Months Selected`);
        } else {
            message.info(`${value} Months Selected`);
        }
        setLimiter(parseInt(value));
        setSubmit(!submit);
    }

    return (
        <div>
            {/* date range filter */}
            <Row type='flex' style={{ margin: '5px', padding: '1px' }}>
                <Col className='gutter-row' span={1}></Col>
                <Col className='gutter-row' span={14}>
                    <Card bordered={false} style={{ height: 70, margin: '1px', padding: '1px' }}>
                        <Tooltip title='Month Filter'>
                            <Space>
                                <Select
                                    showSearch
                                    defaultValue={'last ' + limiter + ' Months'}
                                    style={{ width: 400 }}
                                    placeholder='Month Filter'
                                    optionFilterProp='children'
                                    onChange={onChange}
                                    filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    <Option value='6'>last 6 Months</Option>
                                    <Option value='12'>last 12 Months</Option>
                                    <Option value='24'>last 24 Months</Option>
                                    <Option value='100'>All Months</Option>
                                </Select>
                            </Space>
                        </Tooltip>
                    </Card>
                </Col>
            </Row>

            {/* appRes Vs errApp */}
            <Row style={{ margin: '5px', padding: '1px' }}>
                <Col className='gutter-row' span={1}></Col>
                <Col className='gutter-row' span={22}>
                    <Card
                        title={'New Apps Researched and Number of Errors Per Apps'}
                        size='small'
                        headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                        bordered={false}
                        style={{ height: 550, margin: '1px', padding: '1px' }}
                    >
                        <div>
                            <FetchLine
                                label={trendData['labelDt']}
                                data1={trendData['appRes2appErr']['app_res']}
                                data2={trendData['appRes2appErr']['app_err']}
                                trendLoad={trendLoad}
                                chngLoad={chngLoad}
                                submit={submit}
                                HeadLabel={['New Apps Researched', 'Number of Errors per App']}
                                comms={trendData['appRes2appErr']['app_comms']}
                            />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <label style={{ fontSize: '12px', color: 'grey' }}>
                                Number may vary based on resource alignment subject to priorities.
                            </label>
                        </div>
                    </Card>
                </Col>
            </Row>

            {/* App Researched by ML */}
            <Row style={{ margin: '5px', padding: '1px' }}>
                <Col className='gutter-row' span={1}></Col>
                <Col className='gutter-row' span={22}>
                    <Card
                        title={'New Apps Researched by ML'}
                        size='small'
                        headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                        bordered={false}
                        style={{ height: 380, margin: '1px', padding: '1px' }}
                    >
                        <div>
                            <NLineGraph
                                label={trendData['labelRel']}
                                data={[
                                    ndataline('New Apps Researched By ML', trendData['app_res_ml'], labelL1, graphColors['darkgreen'], {}),
                                ]}
                                trendLoad={trendLoad}
                                chngLoad={chngLoad}
                                submit={submit}
                            />
                        </div>
                    </Card>
                </Col>
            </Row>

            {/* avgAppRes */}
            <Row style={{ margin: '5px', padding: '1px' }}>
                <Col className='gutter-row' span={1}></Col>
                <Col className='gutter-row' span={22}>
                    <Card
                        title={'Average Number of Apps Researched/Day/Researcher'}
                        size='small'
                        headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                        bordered={false}
                        style={{ height: 380, margin: '1px', padding: '1px' }}
                    >
                        <div>
                            <Fetch1Line
                                label={trendData['labelDt']}
                                data1={trendData['avgAppRes']}
                                trendLoad={trendLoad}
                                chngLoad={chngLoad}
                                submit={submit}
                                HeadLabel={['Average Number of Apps Researched/Day/Researcher']}
                            />
                        </div>
                    </Card>
                </Col>
            </Row>

            {/* appRef */}
            <Row style={{ margin: '5px', padding: '1px' }}>
                <Col className='gutter-row' span={1}></Col>
                <Col className='gutter-row' span={22}>
                    <Card
                        title={'Apps Refreshed'}
                        size='small'
                        headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                        bordered={false}
                        style={{ height: 380, margin: '1px', padding: '1px' }}
                    >
                        <div>
                            <Fetch1Line
                                label={trendData['labelDt']}
                                data1={trendData['appsRef']}
                                trendLoad={trendLoad}
                                chngLoad={chngLoad}
                                submit={submit}
                                HeadLabel={['Apps Refreshed']}
                            />
                        </div>
                    </Card>
                </Col>
            </Row>

            {/* CusReqApp */}
            <Row style={{ margin: '5px', padding: '1px' }}>
                <Col className='gutter-row' span={1}></Col>
                <Col className='gutter-row' span={22}>
                    <Card
                        title={'Customer requested Apps'}
                        size='small'
                        headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                        bordered={false}
                        style={{ height: 380, margin: '1px', padding: '1px' }}
                    >
                        <div>
                            <Fetch1Line
                                label={trendData['labelDt']}
                                data1={trendData['cusReq']}
                                trendLoad={trendLoad}
                                chngLoad={chngLoad}
                                submit={submit}
                                HeadLabel={['Customer requested Apps']}
                            />
                        </div>
                    </Card>
                </Col>
            </Row>

            {/* Breached Apps */}
            <Row style={{ margin: '5px', padding: '1px' }}>
                <Col className='gutter-row' span={1}></Col>
                <Col className='gutter-row' span={22}>
                    <Card
                        title={'Breached Apps'}
                        size='small'
                        headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                        bordered={false}
                        style={{ height: 380, margin: '1px', padding: '1px' }}
                    >
                        <div>
                            <Fetch1Line
                                label={trendData['labelDt']}
                                data1={trendData['breach']}
                                trendLoad={trendLoad}
                                chngLoad={chngLoad}
                                submit={submit}
                                HeadLabel={['Breached Apps']}
                            />
                        </div>
                    </Card>
                </Col>
            </Row>

            {/* Japanese Apps */}
            <Row style={{ margin: '5px', padding: '1px' }}>
                <Col className='gutter-row' span={1}></Col>
                <Col className='gutter-row' span={22}>
                    <Card
                        title={'Japanese Apps'}
                        size='small'
                        headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                        bordered={false}
                        style={{ height: 380, margin: '1px', padding: '1px' }}
                    >
                        <div>
                            <Fetch1Line
                                label={trendData['labelDt']}
                                data1={trendData['japanese']}
                                trendLoad={trendLoad}
                                chngLoad={chngLoad}
                                submit={submit}
                                HeadLabel={['Japanese Apps']}
                            />
                        </div>
                    </Card>
                </Col>
            </Row>

            {/* CusReqApp */}
            <Row style={{ margin: '5px', padding: '1px' }}>
                <Col className='gutter-row' span={1}></Col>
                <Col className='gutter-row' span={22}>
                    <Card
                        title={'Number of Apps release over release'}
                        size='small'
                        headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                        bordered={false}
                        style={{ height: 380, margin: '1px', padding: '1px' }}
                    >
                        <div>
                            <NLineGraph
                                label={trendData['labelRel']}
                                data={[
                                    ndataline('Apps with CCI', trendData['appsRel'], labelL1, graphColors['darkgreen'], {
                                        type: 'appsRes',
                                        unres: trendData['unRes'],
                                    }),

                                    ndataline2('Inactive Apps', trendData['inactiveFill'], labelL2, graphColors['red'], '-1', {
                                        type: 'inactive',
                                        inactive: trendData['inactive'],
                                    }),
                                    ndataline2('Discovery Only Apps', trendData['discoveryFill'], labelL2, graphColors['grey'], '-1', {
                                        type: 'discovery',
                                        discovery: trendData['discovery'],
                                    }),
                                    ndataline2('Apps For CCI Research', trendData['unResFill'], labelL2, graphColors['green'], '-1', {
                                        type: 'unres',
                                        unRes: trendData['unRes'],
                                    }),
                                    ndataline('Total Apps', trendData['totalAppsRel'], labelL2, graphColors['orange'], {
                                        type: 'totalApps',
                                        inactive: trendData['inactive'],
                                        discovery: trendData['discovery'],
                                    }),
                                ]}
                                trendLoad={trendLoad}
                                chngLoad={chngLoad}
                                submit={submit}
                            />
                        </div>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

const NLineGraph = (props) => {
    const [lineData, setLineData] = useState([]);
    const [load, setLoading] = useState(true);
    useEffect(() => {
        setLoading(true);
        setLineData({
            trend: props.trendData,
            label: props.label,
            dataSet: props.data,
        });
        setLoading(false);
        console.log('hey props ');
    }, [props.chngLoad]);

    return (
        <div style={{ margin: '5px', padding: '1px' }}>
            {load ? (
                <div>
                    <Spin className={styles.spinner} size='small' />
                </div>
            ) : (
                <Card size='small' headStyle={{ backgroundColor: '#FDEEF4', border: 0 }} bordered={false}>
                    <Line
                        height={300}
                        data={{
                            labels: lineData['label'],
                            datasets: lineData['dataSet'],
                        }}
                        options={gradientOpt2}
                    />
                </Card>
            )}
        </div>
    );
};

const Fetch1Line = (props) => {
    const [lineData, setLineData] = useState([]);
    const [load, setLoading] = useState(true);
    useEffect(() => {
        setLoading(true);
        setLineData({
            trend: props.trendData,
            label: props.label,
            dataSet1: props.data1,
            dataSet2: props.data2,
            head: props.HeadLabel,
        });
        setLoading(false);
        console.log('hey props ');
    }, [props.chngLoad]);

    return (
        <div style={{ margin: '5px', padding: '1px' }}>
            {load ? (
                <div>
                    <Spin className={styles.spinner} size='small' />
                </div>
            ) : (
                <Card size='small' headStyle={{ backgroundColor: '#FDEEF4', border: 0 }} bordered={false}>
                    <Line
                        height={300}
                        data={{
                            labels: lineData['label'],
                            datasets: [data1(lineData['head'], lineData['dataSet1'], labelL2)],
                        }}
                        options={gradientOpt1}
                    />
                </Card>
            )}
        </div>
    );
};

const FetchLine = (props) => {
    const [lineData, setLineData] = useState([]);
    const [load, setLoading] = useState(true);
    useEffect(() => {
        setLoading(true);
        setLineData({
            trend: props.trendData,
            label: props.label,
            dataSet1: props.data1,
            dataSet2: props.data2,
            head: props.HeadLabel,
            comms: props.comms,
        });
        setLoading(false);
        console.log('hey props ');
    }, [props.chngLoad]);

    return (
        <div style={{ margin: '5px', padding: '1px' }}>
            {load ? (
                <div>
                    <Spin className={styles.spinner} size='small' />
                </div>
            ) : (
                <Card size='small' headStyle={{ backgroundColor: '#FDEEF4', border: 0 }} bordered={false}>
                    <Line
                        height={430}
                        data={{
                            labels: lineData['label'],
                            datasets: [
                                data1(lineData['head'][0], lineData['dataSet1'], labelL2, lineData['comms']),
                                data2(lineData['head'][1], lineData['dataSet2'], labelL1),
                            ],
                        }}
                        options={gradientOpt}
                    />
                </Card>
            )}
        </div>
    );
};

const ndataline = (lineHead, lineData, align, color, comms) => {
    return {
        label: lineHead,
        fill: false,
        pointStyle: 'circle',
        borderColor: color + ', 1)',
        borderCapStyle: 'butt',
        display: 'auto',
        borderDash: [],
        borderJoinStyle: 'miter',
        backgroundColor: color + ', 0.2)',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBorderWidth: 2,
        pointRadius: 3,
        pointHitRadius: 10,
        data: lineData,
        datalabels: align,
        comments: comms,
    };
};

const ndataline2 = (lineHead, lineData, align, color, fill, comms) => {
    return {
        label: lineHead,
        fill: fill,
        display: 'auto',
        borderDash: [],
        borderWidth: 0,
        borderJoinStyle: 'miter',
        backgroundColor: color + ', 0.2)',
        pointRadius: 0,
        data: lineData,
        datalabels: { display: false },
        comments: comms,
    };
};

const data1 = (lineHead, lineData, align, comms) => {
    return {
        label: lineHead,
        fill: false,
        pointStyle: 'circle',
        borderColor: '#00991a',
        borderCapStyle: 'butt',
        display: 'auto',
        borderDash: [],
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: 'rgba(102, 245, 66,0.2)',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 3,
        pointHitRadius: 10,
        data: lineData,
        datalabels: align,
        comments: comms,
    };
};

const data2 = (lineHead, lineData, align) => {
    return {
        label: lineHead,
        yAxisID: 'B',
        fill: false,
        pointStyle: 'circle',
        borderCapStyle: 'butt',
        display: 'auto',
        borderDash: [],
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: '#f5222d',
        borderColor: '#f5222d',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 3,
        pointHitRadius: 10,
        data: lineData,
        datalabels: align,
    };
};

const labelL2 = {
    anchor: 'top',
    align: 'end',
    offset: 3,
    borderRadius: 4,
};

const labelL1 = {
    display: 'auto',
    anchor: 'bottom',
    align: 'start',
    offset: 3,
    borderRadius: 4,
};

const yAxes = {
    dualYaxes: [
        {
            id: 'A',
            type: 'linear',
            position: 'left',
            ticks: {
                suggestedMin: 0,
                padding: 20,
                fontColor: '#9a9a9a',
            },
            gridLines: {
                drawBorder: false,
                display: false,
            },
        },
        {
            id: 'B',
            type: 'linear',
            position: 'right',
            ticks: {
                padding: 15,
                stepSize: 1,
                max: 4,
                min: 0,
                fontColor: 'red',
            },
            gridLines: {
                drawBorder: false,
                display: false,
            },
        },
    ],
    singYaxes: [
        {
            ticks: {
                padding: 20,
            },
            gridLines: {
                drawBorder: false,
                display: false,
            },
        },
    ],
};

const xAxes = [
    {
        barPercentage: 1.6,
        gridLines: {
            drawBorder: false,
            color: 'rgba(225,78,202,0.1)',
            zeroLineColor: 'transparent',
        },
        ticks: {
            display: true,
            padding: 20,
            fontColor: '#9a9a9a',
        },
    },
];

const toolTip = {
    backgroundColor: '#f5f5f5',
    titleFontColor: '#333',
    bodyFontColor: '#666',
    bodySpacing: 4,
    xPadding: 12,
    mode: 'nearest',
    intersect: 0,
    position: 'nearest',
};

const toolTip1 = {
    enabled: true,
    mode: 'nearest',
    callbacks: {
        afterFooter: function (tooltipItems, data) {
            let da = data['datasets'][0]['comments'][tooltipItems[0]['index']];
            da = Array.isArray(da)
                ? da
                      .filter((x) => x !== '')
                      .map((x) => x.trim())
                      .join('\n*')
                : da;
            if (da && tooltipItems[0]['datasetIndex'] === 0) return '*' + da;
            else return '';
        },
    },
    backgroundColor: '#f5f5f5',
    titleFontColor: '#333',
    bodyFontColor: '#666',
    footerFontColor: '#566573',
    bodySpacing: 4,
    xPadding: 12,
    intersect: 0,
    position: 'nearest',
};

const toolTip2 = {
    enabled: true,
    mode: 'nearest',
    callbacks: {
        label: function (tooltipItems, data) {
            let cmntType = data['datasets'][tooltipItems.datasetIndex]['comments'].type;
            let label = data['datasets'][tooltipItems.datasetIndex]['label'].split('(')[0];
            if (cmntType === 'inactive')
                return label + ' : ' + data.datasets[tooltipItems.datasetIndex]['comments'].inactive[tooltipItems.index];
            if (cmntType === 'discovery')
                return label + ' : ' + data.datasets[tooltipItems.datasetIndex]['comments'].discovery[tooltipItems.index];
            if (cmntType === 'unres') return label + ' : ' + data.datasets[tooltipItems.datasetIndex]['comments'].unRes[tooltipItems.index];
            return label + ' : ' + data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index];
        },
    },
    backgroundColor: '#f5f5f5',
    titleFontColor: '#333',
    bodyFontColor: '#666',
    footerFontColor: '#566573',
    bodySpacing: 4,
    xPadding: 12,
    intersect: 0,
    position: 'nearest',
};

const legend = {
    display: true,
    position: 'bottom',
    labels: {
        usePointStyle: true,
        fontColor: '#333',
    },
};

const layout = {
    padding: {
        top: 20,
    },
};

const gradientOpt = {
    scales: {
        yAxes: yAxes['dualYaxes'],
        xAxes: xAxes,
    },
    layout: layout,
    tooltips: toolTip1,
    responsive: true,
    maintainAspectRatio: false,
    legend: legend,
};

const gradientOpt1 = {
    scales: {
        yAxes: yAxes['singYaxes'],
        xAxes: xAxes,
    },
    layout: layout,
    tooltips: toolTip,
    responsive: true,
    maintainAspectRatio: false,
    legend: legend,
};

const gradientOpt2 = {
    scales: {
        yAxes: yAxes['singYaxes'],
        xAxes: xAxes,
    },
    layout: layout,
    tooltips: toolTip2,
    responsive: true,
    maintainAspectRatio: false,
    legend: legend,
};

const graphColors = {
    green: 'rgba(0, 255, 0',
    darkgreen: 'rgba(0, 153, 26',
    red: 'rgba(255, 0, 0',
    blue: 'rgba(0, 0, 255',
    skyblue: 'rgba(0, 204, 255',
    orange: 'rgba(245, 94, 0',
    grey: 'rgba(128, 128, 128',
};

export default CciTrend;
